<template>
  <div>
    <Icon
      :width="60"
      :height="60"
      class="mb-5"
      :color="'rgba(0,0,0,.54)'"
      :icon="'phone-forward-outline'"
    />
    <h3 class="font-weight-bold mb-2">
      {{$t('thankYouPage.contactRequest.title')}}
    </h3>
    <p class="text--secondary pb-5">
      {{$t('thankYouPage.contactRequest.description')}}
    </p>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class ContactRequestMessage extends Vue {}
</script>
